import LoadingSpinner from '../../StatusIndicators/LoadingSpinner'
import SystemStatus from '../SystemState'

export const SystemLoading = ({ text }: { text?: string }) => (
  <SystemStatus>
    <LoadingSpinner text={text} />
  </SystemStatus>
)
